import type { ChartConfig } from '@/components/ui'

/**
 * Dashboard series colours. Attended reads in the brand teal, absence in the
 * brand coral, so the two charts and the KPI tiles speak one language. Dark
 * values are lifted so the marks keep contrast on gray-800.
 */
export const ATTENDANCE_SERIES = {
  present: { label: 'Attended', theme: { light: '#004a6b', dark: '#4aa3c4' } },
  late: { label: 'Late', theme: { light: '#e09a00', dark: '#fbbf24' } },
  absent: { label: 'Absent', theme: { light: '#ff4d6d', dark: '#ff7a91' } },
  onLeave: { label: 'On leave', theme: { light: '#8fb8cc', dark: '#5f7f90' } },
} satisfies ChartConfig

export const TREND_SERIES = {
  thisWeek: { label: 'This week', theme: { light: '#004a6b', dark: '#4aa3c4' } },
  lastWeek: { label: 'Last week', theme: { light: '#ff4d6d', dark: '#ff7a91' } },
} satisfies ChartConfig
